import { render } from "./IconUpload.vue?vue&type=template&id=26b81768"
import script from "./IconUpload.vue?vue&type=script&lang=js"
export * from "./IconUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__